import { QueuePlaybackService } from "../services/QueuePlaybackService";
import React, {useState} from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonIcon,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonProgressBar,
} from "@ionic/react";
import {
  ellipsisHorizontalOutline,
  pause as pauseIcon,
  play as playIcon,
  playBack,
  playForward,
  removeOutline,
} from "ionicons/icons";

import {usePlayer} from "../data/store/usePlayer";
import {usePlaylist} from "../data/store/usePlaylist";
import {useSongs} from "../data/store/useSongs";
import MediaService from "../services/MediaService";

import {Song} from "../models/Song";
import AvailablePlaylists from "./AvailablePlaylists";

interface PlaylistProps {
}

const Playlist: React.FC<PlaylistProps> = () => {
  const {
    setNowPlaying,
    nextSong,
    previousSong,
    removeSong,
    songs,
    nowPlayingId,
  } = usePlaylist();
  const {isPaused} = usePlayer();
  const {retrieve} = useSongs();
  const [popoverState, setShowPopover] = useState(false);

  const popoverDismiss = () => {
    setShowPopover(false);
  };

  const playSongNow = async (id: string) => {
    const song = await QueuePlaybackService.load(id);
    if (!song) return;
    MediaService.please()
      .setSong(song)
      .then(async () => {
        setNowPlaying(id);
        await MediaService.please().play();
      })
      .catch((error) => console.warn("[queue] could not play", id, error));
  };

  const setAndPlay = (song: Song) => {
    MediaService.please()
      .setSong(song)
      .then(async () => {
        await MediaService.please().play();
      });
  };

  const playPrev = () => {
    QueuePlaybackService.playStep("previous");
  };

  const playNext = () => {
    QueuePlaybackService.playStep("next");
  };

  function renderPlayList(songs: string[]) {
    return songs.map((songId) => {
      const song = retrieve(songId);
      if (!song) {
        return (
          <IonItem>
            <IonProgressBar type="indeterminate"/>
          </IonItem>
        );
      }

      return (
        <IonItemSliding key={song.id}>
          <IonItem
            color={nowPlayingId === song.id ? "primary" : undefined}
            onClick={() => playSongNow(song.id)}
          >
            <IonLabel>{song.title}</IonLabel>
          </IonItem>
          <IonItemOptions side="end">
            <IonItemOption
              color="danger"
              onClick={() => {
                if (songs.length === 1) MediaService.please().pause();
                removeSong(song.id);
                if (nowPlayingId === song.id) nextSong();
              }}
              aria-label="Remove song from playlist"
            >
              <IonIcon icon={removeOutline} aria-hidden="true"/>
            </IonItemOption>
          </IonItemOptions>
        </IonItemSliding>
      );
    });
  }

  return (
    <IonMenu side="end" menuId="playlist" type="overlay" contentId="main">
      <IonContent forceOverscroll={false}>
        <IonList lines="none">
          <IonListHeader>
            <IonLabel>Playlist</IonLabel>
            <IonButton
              aria-label="Playlist options"
              onClick={(event: any) => {
                // event.persist();
                setShowPopover( true);
              }}
            >
              <IonIcon
                size="large"
                color="dark"
                icon={ellipsisHorizontalOutline}
                aria-hidden="true"
              />
            </IonButton>

            
              <AvailablePlaylists
                popoverState={popoverState}
                popoverDismiss={popoverDismiss}
                nowPlayingId={nowPlayingId}
              />
          </IonListHeader>

          {renderPlayList(songs)}
        </IonList>
      </IonContent>

      <IonFooter>
        <IonList lines="none" style={{textAlign: "center"}}>
          <IonItem style={{textAlign: "center"}}>
            <IonButtons>
              {songs.length > 1 && (
                <IonButton onClick={playPrev} aria-label="Previous track">
                  <IonIcon icon={playBack} aria-hidden="true"/>
                </IonButton>
              )}

              {isPaused && nowPlayingId && (
                <IonButton onClick={() => MediaService.please().play()} aria-label="Play">
                  <IonIcon icon={playIcon} aria-hidden="true"/>
                </IonButton>
              )}

              {!isPaused && nowPlayingId && (
                <IonButton onClick={() => MediaService.please().pause()} aria-label="Pause">
                  <IonIcon icon={pauseIcon} aria-hidden="true"/>
                </IonButton>
              )}

              {songs.length > 1 && (
                <IonButton onClick={playNext} aria-label="Next track">
                  <IonIcon icon={playForward} aria-hidden="true"/>
                </IonButton>
              )}
            </IonButtons>
          </IonItem>
        </IonList>
      </IonFooter>
    </IonMenu>
  );
};

export default React.memo(Playlist);
